import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-white w-full">
      <div className="container mx-auto py-4 lg:py-6 px-2 flex flex-col md:flex-row justify-between items-center">
        <div>
          <p className="text-base text-center md:text-left">
            <span className="opacity-30">© 2022 Kerakoll. All rights reserved. |{" "}</span>
            <a
              className="text-white hover:text-white hover:underline cursor-pointer"
              href="https://www.kerakoll.com"
            >
              www.kerakoll.com
            </a>
          </p>
        </div>
        <div className="flex gap-6 my-auto">
          <a href="https://www.facebook.com/kerakollofficial/" className="block grid place-content-center w-10 h-10">
            <img src={process.env.PUBLIC_URL + "/Social/Facebook.svg"} alt="facebook" />
          </a>
          <a href="https://www.instagram.com/kerakollofficial/" className="block grid place-content-center w-10 h-10">
            <img src={process.env.PUBLIC_URL + "/Social/Instagram.svg"} alt="instagram" />
          </a>
          <a href="https://www.youtube.com/channel/UCmUPU6-xDwpsh_nrrAxwttw" className="block grid place-content-center w-10 h-10 ">
            <img src={process.env.PUBLIC_URL + "/Social/YouTube.svg"} alt="youtube" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
